import { createContext, useContext } from 'react';

export const BrandContext = createContext(process.env.REACT_APP_BRAND);

export const useBrand = () => useContext(BrandContext);
